import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import {
  AccountSettingGroupShape,
} from './services';
import DisplayTableError, { DisplayErrorShape } from '../../../../../shared/components/widgets/DisplayTableError';
import DisplaySettingGroup from './DisplaySettingGroup';
import EditSettingGroup from './EditSettingGroup';

export default function DisplaySettingGroupsTable({
  data, toggleEdit, doSave, doDelete, displayError, resetError, isDarkMode,
}) {
  const tdStyle = {
    color: isDarkMode ? '#dddddd' : '#212529',
    backgroundColor: isDarkMode ? '#2a2d3a' : '#ffffff',
    borderColor: isDarkMode ? '#434651' : '#dee2e6',
  };

  return data.map(item => (
    <Fragment key={item.settingGroupId}>
      <DisplayTableError
        displayError={displayError}
        resetError={resetError}
        colSpan={5}
        checkErrorId={item.settingGroupId}
      />
      <tr>
        <td style={tdStyle}>{ item.settingGroupId }</td>
        {!item.editMode && (
          <DisplaySettingGroup
            item={item}
            toggleEdit={toggleEdit}
            doDelete={doDelete}
            tdStyle={tdStyle}
          />
        )}
        {item.editMode && (
          <EditSettingGroup
            item={item}
            toggleEdit={toggleEdit}
            doSave={doSave}
            tdStyle={tdStyle}
          />
        )}
      </tr>
    </Fragment>
  ));
}

DisplaySettingGroupsTable.defaultProps = {
  displayError: undefined,
  resetError: data => data,
  isDarkMode: false,
};

DisplaySettingGroupsTable.propTypes = {
  data: PropTypes.oneOfType([
    PropTypes.shape(AccountSettingGroupShape),
    PropTypes.arrayOf(PropTypes.shape(AccountSettingGroupShape)),
  ]).isRequired,
  toggleEdit: PropTypes.func.isRequired,
  doSave: PropTypes.func.isRequired,
  doDelete: PropTypes.func.isRequired,
  displayError: PropTypes.shape(DisplayErrorShape),
  resetError: PropTypes.func,
  isDarkMode: PropTypes.bool,
};
